module.exports = __webpack_public_path__ + "images/map-texture.4b99f931.png";